<template>
    <v-app>
        <v-app-bar app color="#231f20" dark>
            <v-layout justify-space-between fill-height align-center>
                <div class="logo-and-lang" style="display: flex; align-items: center;">
                    <div @click="backToApp" style="cursor:pointer">
                        <LogoLarge />
                    </div>
                    <LanguageDropdown class="ml-8" />
                </div>
                <v-flex md6 v-if="!smAndDown">
                    <v-layout class="btn-span" justify-center align-center>
                        <!-- <div> -->
                        <form v-show="callListNumbers.length === 0 && !weaLink">
                            <v-layout>
                                <span v-if="isActive===true" class="track-numbers-button">
                                    <FindByNumbersModal>
                                        <v-btn 
                                            outlined
                                            dark 
                                            data-test
                                            style="margin:12px 0 0 -2px;height:48px;"
                                        >{{ t('layouts.overwatch.locateNumbers') }}</v-btn>
                                    </FindByNumbersModal>
                                </span>
                                <span v-else class="track-line-button">
                                    <FindByListModal>
                                        <v-btn 
                                            outlined
                                            dark 
                                            data-test
                                            style="margin:12px 0 0 -2px;height:48px;"
                                        >{{ t('layouts.overwatch.locateByList') }}</v-btn>
                                    </FindByListModal>
                                </span>
                                <v-switch
                                    v-model="isActive"
                                    class="type-toggle"
                                    color="error"
                                ></v-switch>
                            </v-layout>
                            <v-snackbar
                                v-model="showErrorSnackbar"
                                :timeout="3000"
                                top
                                left
                                data-test="valid-phone-number-error-snackbar"
                                >{{ t('layouts.overwatch.validPhoneError') }}
                            </v-snackbar>
                        </form>
                        <span v-show="!(callListNumbers.length === 0 && !weaLink)">
                            <span style="margin-right:10px">{{ t('layouts.overwatch.locating') }}</span>

                            <span class="end-tracking-container">
                                <EndOverwatchTrackingModal>
                                    <v-btn outlined dark data-test="end-tracking-button">{{ t('layouts.overwatch.endTracking') }}</v-btn>
                                </EndOverwatchTrackingModal>
                            </span>
                        </span>
                    </v-layout>
                    <!-- </div> -->
                </v-flex>
                <v-flex style="display: flex; align-items: center; justify-content: flex-end;" sm6 md3>
                    <template v-if="customHeaderLinks">
                        <v-btn
                            text
                            dark
                            v-for="(link, index) in customHeaderLinks"
                            :key="index"
                            :href="link.link"
                            target="_blank"
                        >{{ link.name }}</v-btn>
                    </template>
                    <UserMenu :user="user" :subtitle="user.companyName">
                        <UserMenuItem icon="map_marker_alt" @click="backToApp">
                            {{ t('layouts.overwatch.backToMap') }}
                        </UserMenuItem>
                        <UserMenuItem v-if="isUserAdmin" icon="users" :to="{ name: 'admin' }">
                            {{ t('layouts.overwatch.admin') }}
                        </UserMenuItem>
                        <UserMenuItem v-if="isUserAdmin" icon="viewer" :to="{ name: 'liveteam' }">
                            {{ t('layouts.app.teamTrack') }}
                        </UserMenuItem>
                        <UserMenuItem icon="file" @click="toTraining">
                            {{ t('layouts.overwatch.trainingVideos') }}
                        </UserMenuItem>
                        <UserMenuItem
                            v-for="(link, index) in customHeaderDropdownLinks"
                            :key="index"
                            icon="link"
                            :href="link.link"
                            target="_blank"
                        >
                            {{ link.name }}
                        </UserMenuItem>
                        <UserMenuItem icon="sign_out" danger @click="signOut">
                            {{ t('layouts.overwatch.signOut') }}
                        </UserMenuItem>
                    </UserMenu>
                </v-flex>
            </v-layout>
        </v-app-bar>
        <v-main>
            <v-alert v-if="seen" class="alert" :style="{ position: 'fixed', top: 50, zIndex:1 }"><p class="sms-text">{{ t('layouts.overwatch.smsReceived') }}</p></v-alert>
            <slot />
        </v-main>
        <!-- <DashboardTour /> -->
    </v-app>
</template>

<script lang="ts">
import Vue from 'vue'
import store from '@/store'

// Must be high in the componnet heirarchy for correct DOM positioning.
import DashboardTour from '@/components/DashboardTour.vue'
import EndOverwatchTrackingModal from '@/components/EndOverwatchTrackingModal.vue'
import FindByNumbersModal from '@/components/FindByNumbersModal.vue'
import FindByListModal from '@/components/FindByListModal.vue'
import { eventBus } from '@/main'
import LogoLarge from '@/components/LogoLarge.vue'

export default Vue.extend({
    data() {
        return {
            showErrorSnackbar: false,
            isActive: true,
            seen: false
        }
    },
    methods: {
        t(key: string): string {
            return (this as any).$t(key)
        },
        backToApp() {
            this.$router.push({ name: 'dashboard' })
        },
        toggleDimensions() {
            this.isActive = !this.isActive;
        },
        signOut() {
            store.dispatch('authentication/logout')
            store.dispatch('location/reset')
            // this.$tours.dashboardTour.stop()
            this.$router.push({
                name: 'auth-sign-in'
            })
        },
        triggerSmsBanner() {
            this.seen = true;
            setTimeout(() => {
                this.seen = false;
            }, 3000);
        },
        toTraining() {
            this.$router.push({
                name: 'training'
            })
        },
    },
    computed: {
        phoneNumber: {
            get(): string {
                return store.state.location.phoneNumber
            },
            set(value: string) {
                store.commit('location/phoneNumber', value)
            }
        },
        log(): any {
            return store.state.location.log
        },
        smAndDown(): any {
            return this.$vuetify.breakpoint.smAndDown
        },
        callListNumbers(): any {
            return store.state.location.callListNumbers
        },
        user(): any {
            return store.state.authentication.currentUser
        },
        customHeaderDropdownLinks(): any {
            const teams = store.state.authentication.teams
            if (!teams || teams.length == 0) return []

            const team = teams[0]
            const links = team.customContent && team.customContent.links && team.customContent.links.headerDropdown
            if (links) return links
            return []
        },
        customHeaderLinks(): any {
            const teams = store.state.authentication.teams
            if (!teams || teams.length == 0) return []

            const team = teams[0]
            const links = team.customContent && team.customContent.links && team.customContent.links.header
            if (links) return links
            return []
        },
        isUserAdmin() {
            const user = store.state.authentication.currentUser
            return user && (user.isAdmin || user.isTeamAdmin || user.isAgencyAdmin)
        },
        weaLink() {
            return store.state.location.weaLink;
        }
    },
    created() {
        eventBus.$on('triggerSmsBanner', () => {
            this.triggerSmsBanner()
        })
    },
    components: {
        EndOverwatchTrackingModal,
        FindByNumbersModal,
        FindByListModal
    }
})
</script>
<style lang="scss">

.btn-span {
    padding-left: 50% !important;
}

.v-step {
    z-index: 100;
}

.type-toggle {
    padding: 22px 0 0px 25px !important;
}

// .location-number-container {
//     @media (max-width: 1244px) {
//         position: relative;
//         float: left;
//         width: 70%;
//         top: 15px;
//         margin: 0;
//     }
// }

// .end-tracking-container {
//     @media (max-width: 1244px) {
//         position: relative;
//         float: right;
//         width: 30%;
//         margin: 0;
//     }
// }
</style>